module.exports = __webpack_public_path__ + "img/dot.ec4bb434.svg";